var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70595 0.659436L1.84414 4.53414L1.83984 4.53844C1.81406 4.56637 1.7829 4.59108 1.74853 4.61041C1.68837 4.64479 1.62177 4.6609 1.55732 4.6609C1.42304 4.6609 1.29199 4.59108 1.22109 4.46539L0.0512642 2.42008C-0.0550834 2.23424 0.00936966 1.99791 0.19521 1.89264C0.381049 1.78629 0.617377 1.85074 0.722651 2.03658L1.64003 3.64254L5.1581 0.113733C5.30849 -0.0377316 5.55341 -0.0377316 5.70488 0.112659C5.85634 0.264124 5.85634 0.509046 5.70595 0.659436Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.37583c02af88c02aa464a57a130c6eca.svg";
export { ForwardRef as ReactComponent };